import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '@hrlabs/shared-types';
import { listCollection, type Row } from '../../lib/db';

export function ServiceList() {
  const [docs, setDocs] = useState<Map<string, Row>>(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCollection('servicePages').then((rows) => {
      setDocs(new Map(rows.map((r) => [r.id, r])));
      setLoading(false);
    });
  }, []);

  return (
    <>
      <h3 className="fw-bold mb-1">Service pages</h3>
      <p className="text-muted small mb-3">
        The eleven service pages. Names, URLs and menu groups are fixed in code; you edit each
        page&apos;s content here. Only <strong>published</strong> pages appear in the site menu,
        the hub and the sitemap.
      </p>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover align-middle">
          <thead>
            <tr>
              <th>Service</th>
              <th>EN URL</th>
              <th>BG URL</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {SERVICES.map((s) => {
              const status = String(docs.get(s.key)?.status ?? 'not created');
              return (
                <tr key={s.key}>
                  <td>{s.name.en}</td>
                  <td className="small text-muted">/services/{s.slug.en}/</td>
                  <td className="small text-muted">/uslugi/{s.slug.bg}/</td>
                  <td>
                    <span className={`badge ${status === 'published' ? 'bg-success' : 'bg-secondary'}`}>{status}</span>
                  </td>
                  <td className="text-end">
                    <Link to={`/services/${s.key}`} className="btn btn-sm btn-outline-secondary">Edit</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
